/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Přibyl (pribyl@cadwork.cz)
 *
 */

export default
class MemoryManagement {

    private static _gpuTexturesMemLimit: number = 1024 * 1024 * 1024;
    private static _updated: boolean = false;

    /***
     * The shader memory is estimated based on windows chrome:
     * Running chrome no tab:  16 MB on pgu
     * Opening simple mode:   161 MB on gpu
     * Buffers:                53.2 (1920 * 1080)
     * Canvas:           (depth + stencil + color) = 2 x 4 * (1920 * 1080) = 16MB, * 4 x MSAA = 64MB
     * Antialias on: (webglcontext settings) the size of the Canvas memory is multiplied by gl.getParameter(gl.SAMPLES); (see the renderer info in engine console, obivous value is 4x?)
     * Cube geometry:           3.1
     * ------------------------------------------
     *
     * @type {{textures: number, geometry: number, renderBuffers: number, shadersEst}}
     * @private
     */
    private static _gpuMemory: { textures: number, geometry: number, renderBuffers: number } = { textures: 0, geometry: 0, renderBuffers: 0 };

    public static setGPUTexturesMemLimit(aLimitInMB: number)
    {
        MemoryManagement._gpuTexturesMemLimit = aLimitInMB;
    }

    public static getGPUTexturesMemLimit(): number
    {
        return MemoryManagement._gpuTexturesMemLimit;
    }

    public static getOccupiedGPUMemory()
    {
        return MemoryManagement._gpuMemory;
    }

    public static setNeedUpdate(aValue: boolean)
    {
        MemoryManagement._updated = aValue;
    }

    public static getNeedUpdate(): boolean
    {
        return MemoryManagement._updated;
    }

    public static addRenderBufferMem(aWidth: number, aHeight: number, aNumberOfComponents: number): void
    {
        // as we have the mipmap, the size is multiplied by factor of 1.3333
        MemoryManagement._gpuMemory.renderBuffers += (aWidth * aHeight * aNumberOfComponents);
    }

    public static removeRenderBufferMem(aWidth: number, aHeight: number, aNumberOfComponents: number): void
    {
        // as we have the mipmap, the size is multiplied by factor of 1.3333
        MemoryManagement._gpuMemory.renderBuffers -= (aWidth * aHeight * aNumberOfComponents);
    }

    public static addTextureObject(aWidth: number, aHeight: number, aNumberOfComponents: number, aHasMipmaps: boolean): number
    {
        let size = (aWidth * aHeight * aNumberOfComponents * (aHasMipmaps ? 1.3333 : 1.0));

        // as we have the mipmap, the size is multiplied by factor of 1.3333
        MemoryManagement._gpuMemory.textures += size;

        return size;
    }

    public static addCompressedTextureObject(aSize: number): number
    {
        // as we have the mipmap, the size is multiplied by factor of 1.3333
        MemoryManagement._gpuMemory.textures += aSize;

        return aSize;
    }

    public static removeTextureObject(aSize: number): void
    {
        // as we have the mipmap, the size is multiplied by factor of 1.3333
        MemoryManagement._gpuMemory.textures -= aSize;
    }

    public static addBufferObject(aSizeInBytes: number): void
    {
        MemoryManagement._gpuMemory.geometry += aSizeInBytes;
    }

    public static removeBufferObject(aSizeInBytes: number): void
    {
        MemoryManagement._gpuMemory.geometry -= aSizeInBytes;
    }
}

